import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { APIURL } from '../../shared/constants';
import { PdfParams } from '../models/user-manual';

@Injectable()
export class UserManualService {
  private BASE_USER_MANUALS_URL = `${APIURL}userManuals`;

  constructor(private http: HttpClient) {}

  async getPdf({ product, brand, version, lang }: PdfParams): Promise<HttpResponse<Blob>> {
    const url = `${this.BASE_USER_MANUALS_URL}`;
    const params = new HttpParams().set('product', product).set('brand', brand).set('version', version).set('lang', lang);
    return lastValueFrom(this.http.get(url, { params, observe: 'response', responseType: 'blob' }));
  }
}
